import { ComponentPropDefinitions, ComponentPropDefinitionUtil, PropType, WidgetPropDefinitions, WidgetProps } from "@mcleod/components";
import { ObjectUtil } from "@mcleod/core";

export interface HomeWidgetProps extends WidgetProps {
  cellWidth: number;
  cellHeight: number;
  cellX: number;
  cellY: number;
}

let homeWidgetPropDefs: ComponentPropDefinitions;

export class HomeWidgetPropDefinitions {
  public static getDefinitions(): ComponentPropDefinitions {
    if (homeWidgetPropDefs == null) {
      homeWidgetPropDefs = {
        ...WidgetPropDefinitions.cloneDefs(),
        cellHeight: { type: PropType.number, defaultValue: 1, description: "The default number of spaces that this widget should occupy in its container's height.  This is a number between 1 and 8." },
        cellWidth: { type: PropType.number, defaultValue: 1, description: "The default number of spaces that this widget should occupy in its container's width.  This is a number between 1 and 8." },
      };
      ComponentPropDefinitionUtil.populateComponentPropNames(homeWidgetPropDefs);
    }
    return homeWidgetPropDefs;
  }

  public static cloneDefs(): ComponentPropDefinitions {
    return ObjectUtil.deepCopy(HomeWidgetPropDefinitions.getDefinitions());
  }
}
